// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer.css */
.footer {
    background-color: #333; /* Background color of the footer */
    color: white; /* Text color */
    text-align: center; /* Center the text */
    padding: 10px 0; /* Padding for the footer */
    position: relative; /* Positioning */
    bottom: 0; /* Stick to the bottom */
    width: 100%; /* Full width */
    border-top: 2px solid #444; /* subtle line */
}

.footer-content {
    margin: 0 auto; /* Center the content */
    max-width: 1200px; /* Max width for the content */
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,sBAAsB,EAAE,mCAAmC;IAC3D,YAAY,EAAE,eAAe;IAC7B,kBAAkB,EAAE,oBAAoB;IACxC,eAAe,EAAE,2BAA2B;IAC5C,kBAAkB,EAAE,gBAAgB;IACpC,SAAS,EAAE,wBAAwB;IACnC,WAAW,EAAE,eAAe;IAC5B,0BAA0B,EAAE,gBAAgB;AAChD;;AAEA;IACI,cAAc,EAAE,uBAAuB;IACvC,iBAAiB,EAAE,8BAA8B;AACrD","sourcesContent":["/* Footer.css */\n.footer {\n    background-color: #333; /* Background color of the footer */\n    color: white; /* Text color */\n    text-align: center; /* Center the text */\n    padding: 10px 0; /* Padding for the footer */\n    position: relative; /* Positioning */\n    bottom: 0; /* Stick to the bottom */\n    width: 100%; /* Full width */\n    border-top: 2px solid #444; /* subtle line */\n}\n\n.footer-content {\n    margin: 0 auto; /* Center the content */\n    max-width: 1200px; /* Max width for the content */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
